import {NgModule} from "ng-metadata/core";
import {ActiveFacetsMergeLocationFacetsWithinSingleLibraryService} from "./activeFacetsMergeLocationFacetsWithinSingleLibrary/activeFacetsMergeLocationFacetsWithinSingleLibrary.service";


@NgModule({
    declarations: [
    ],
    providers: [ //place here all transformers that will run on the active facets list
        ActiveFacetsMergeLocationFacetsWithinSingleLibraryService

    ],
    imports:[

    ]
})
export class ActiveFacetsTransformationsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/activeFacetsTransformations/activeFacetsTransformations.module.ts